<template lang="pug">
v-container(:fluid="fluid")
  router-view

</template>

<script>
export default {
  computed: {
    fluid() {
      return !this.$route.meta.container
    }
  }
}
</script>
